<section class="hero-section">
  <div class="hero-content">
    <div class="text-content">
      <h3 class="platform-label">No. 1 Education Plattform</h3>
      
      <div class="main-headline">
        <h1>Das <span class="highlight">Geheimwissen</span> der obersten</h1>
        <h1>0,1% in einer Plattform</h1>
      </div>

      <div class="features">
        <h2>Das lernst du:</h2>
        <ul>
          <li>
            <span class="check-icon">✓</span>
            1:1 Roadmap für deinen finanziellen Fortschritt
          </li>
          <li>
            <span class="check-icon">✓</span>
            HorizonNet Community für High Performer
          </li>
          <li>
            <span class="check-icon">✓</span>
            Wissen als Grundlage smarter Entscheidungen

          </li>
        </ul>
      </div>

      <div class="cta-section">
        <app-apply-button></app-apply-button>
        <button class="whatsapp-button" (click)="openWhatsApp()">
          <svg class="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
          Jetzt beraten lassen
        </button>
      </div>

      <div class="social-proof">
        <div class="testimonials">
          <div class="profile-pics">
            <img loading="lazy" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b102bb07871299afaf72_referenz-img-klein-2.avif" alt="Testimonial 1">
            <img loading="lazy" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b102dee2f37918c0d88a_referenz-img-klein-1.avif" alt="Testimonial 2">
            <img loading="lazy" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b1024e17b1b2afc7396f_referenz-img-klein-3.avif" alt="Testimonial 3">

          </div>
          <p>Max Prediger und viele weitere haben bereits Zugriff auf HorizonNet.</p>
        </div>
      </div>
    </div>

    <div class="right-content">
      <div class="image-content">
        <!-- Background image is set via CSS -->
      </div>
      <div class="ratings">
        <div class="google-rating">
          <div>
            
          </div>
          <img loading="lazy" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab61978014addd8e2ce3_trust_google.svg" alt="Google">
        
        </div>
        <div class="trustpilot-rating">
          <img loading="lazy" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab6109f893d203c187df_trust_trustpilot.svg" alt="Trustpilot">
         
        </div>
      </div>
    </div>
  </div>
</section> 